export const DynamicFieldsApiUrl = '/platform/v1/accounts/dynamic-forms'

export const DynamicFieldsSections = {
  QUESTIONS: 'questions',
  DOCUMENTS: 'documents',
} as const

export const DynamicFieldsDefaultValue = {
  documents: [],
  questions: [],
}

export const DynamicQuestionCodes = {
  ANY_EXPOSURE_TO_BVNK_PROHIBITED_JURISDICTIONS: 'qAnyExposureToBvnkProhibitedJurisdictions',
  BLOCKCHAIN_MONITORING_TOOL: 'qBlockchainMonitoringTool',
  CLEAN_ASSETS_PURCHASE: 'qCleanAssetsPurchase',
  COIN_ACCEPTANCE_POLICY: 'qCoinAcceptancePolicy',
  COMPLIANCE_MATTER_CONTACT: 'qComplianceMatterContact',
  COMPLY_WITH_AML_REGULATION: 'qComplyWithAmlRegulations',
  CONTACT_DETAILS_FOR_TRAVEL_RULE: 'qContactDetailsForTravelRule',
  FACILITATE_CRYPTO_CURRENCY: 'qFacilitateCryptoCurrency',
  FACILITATE_UNLICENSED_CRYPTO_TOKENS: 'qFacilitateUnlicensedCryptoTokens',
  IDENTIFY_CLIENTS_AND_DUE_DILIGENCE: 'qIdentifyClientsAndDueDiligence',
  INDEPENDENT_MLRO: 'qIndependentMlro',
  IP_CAPTURE: 'qIpCapture',
  KEY_RISKS: 'qKeyRisks',
  MAIN_INDUSTRIES_COMPANY_OPERATES_IN: 'qMainIndustriesCompanyOperatesIn',
  MAIN_INDUSTRIES_COMPANY_TRADES_IN: 'qMainIndustriesCompanyTradesIn',
  MAIN_INDUSTRIES_TOP_CLIENTS_ARE_INVOLVED_IN: 'qMainIndustriesTopClientsAreInvolvedIn',
  MAIN_INDUSTRIES_TOP_CLIENTS_ARE_INVOLVED_IN_BVNK_INVOLVEMENT:
    'qMainIndustriesTopClientsAreInvolvedInBvnkInvolvement',
  MAIN_MARKETS_COMPANY_TRADES_IN: 'qMainMarketsCompanyTradesIn',
  MEASURES_TO_PREVENT_MARKET_MANIPULATION: 'qMeasuresToPreventMarketManipulation',
  MONEY_LAUNDERING_AML_PROCEDURES: 'qMoneyLaunderingAmlProcedures',
  MONITOR_CLIENT_ACTIVITY: 'qMonitorClientActivity',
  NUMBER_OF_FTE_STUFF: 'qNumberOfFteStuff',
  NUMBER_OF_STRS: 'qNumberOfStrs',
  PARENT_COMPANY: 'qParentCompany',
  PAST_REGULATORY_ACTIONS_OR_PENALTIES: 'qPastRegulatoryActionsOrPenalties',
  PROVIDER_FOR_COMPLIANT_DATA_SHARING: 'qProviderForCompliantDataSharing',
  PERIODIC_AML_ASSESSMENT: 'qPeriodicAmlAssessment',
  REGULAR_TECHNICAL_AUDITS_AND_PEN_TESTS: 'qRegularTechnicalAuditsAndPenTests',
  SANCTION_SCREENING: 'qSanctionScreening',
  SEGREGATION_OF_CLIENT_FUNDS: 'qSegregationOfClientFunds',
  SUBSIDIARY_COMPANIES: 'qSubsidiaryCompanies',
  SUPPORT_ICO: 'qSupportIco',
  TRAVEL_RULE_INFORCE: 'qTravelRuleInForce',
  TYPES_OF_CLIENTS_SERVICE_IS_OFFERED_TO: 'qTypesOfClientsServiceIsOfferedTo',
} as const
